<template>
    <el-drawer
        title="权限设置"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <el-form :model="detailData" ref="detailData" size="small">
                    <el-form-item label="管理员：" prop="row.users_array">
                        <el-select
                            v-model="detailData.row.users_array"
                            clearable
                            multiple
                            collapse-tags
                            :loading="userData.loading"
                        >
                            <el-option
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                v-for="item in userData.list"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            type="primary"
                            size="small"
                            :loading="detailData.loading.submit"
                            @click="SubmitDetail('detailData')"
                            >保 存</el-button
                        >
                        <el-button
                            size="small"
                            :disabled="detailData.loading.submit"
                            @click="detailParam.visible = false"
                            >取 消</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { UserData } from '@/plugin/User'
export default {
    inject: ['reload'],
    mixins: [UserData],
    props: ['detailParam'],
    data() {
        return {
            userData: {
                loading: true,
                list: []
            },
            detailData: {
                loading: {
                    main: false,
                    submit: false
                },
                row: {
                    users_array: [],
                    users: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetUser()
        })
    },
    mounted() {
        this.$nextTick(() => {
            this.GetDetail()
        })
    },
    methods: {
        GetUser() {
            if (!this.userData.list.length) {
                this.GetUserData().then(res => {
                    this.userData.loading = false
                    this.userData.list = res.list
                })
            }
        },
        GetDetail() {
            this.detailData.loading.main = true
            this.$request({
                url: '/api/v1/table_power',
                data: {
                    ...this.detailParam.row
                }
            }).then(res => {
                if (!res.status) {
                    this.detailData.loading.main = false
                    this.detailData.row.users_array = []
                    res.data.list.forEach(row => {
                        this.detailData.row.users_array.push(row.user_id)
                    })
                }
            })
        },
        SubmitDetail() {
            this.detailData.row.users = JSON.stringify(this.detailData.row.users_array)
            this.detailData.loading.submit = true
            this.$power({
                data: {
                    ...this.detailParam.row,
                    ...this.detailData.row
                }
            }).then(res => {
                this.detailData.loading.submit = false
                this.$message({
                    message: res.message || (res.status ? '操作失败' : '操作成功'),
                    type: res.status ? 'error' : 'success'
                })
                if (!res.status) {
                    this.reload()
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
